import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthContext, { UserRole } from "../../context/AuthContext";
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setAuth, setUserRole } = useContext(AuthContext);
  const navigate = useNavigate();

  const renewToken = async (token: string) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_ADMIN_API_URL}/api/renew-token/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token);
        setAuth(true);
        setUserRole(data.role as UserRole);
        toast.success("Token renewed successfully!", { closeButton: false, hideProgressBar: true, autoClose: 3000 });
        navigate('/admin/settings', { replace: true });
      } else {
        localStorage.removeItem("token");
        setAuth(false);
        setUserRole(null);
      }
    } catch (error) {
      toast.error("An error occurred while renewing token.", { closeButton: false, hideProgressBar: true, autoClose: 3000 });
    }
  };

  // Проверка токена при монтировании компонента
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      renewToken(token);
    }
  }, []);

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_ADMIN_API_URL}/api/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token);
        setAuth(true);
        setUserRole(data.role as UserRole);
        toast.success("Login successful!", { closeButton: false, hideProgressBar: true, autoClose: 3000 });
        navigate('/admin/settings', { replace: true });
      } else {
        toast.error("Login failed. Please check your credentials.", { closeButton: false, hideProgressBar: true, autoClose: 3000 });
      }
    } catch (error) {
      toast.error("An error occurred during login.", { closeButton: false, hideProgressBar: true, autoClose: 3000 });
    }
  };

  return (
    <div className="login-container">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">
          Login
        </button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default Login;